import { render, staticRenderFns } from "./ranking-item-content.vue?vue&type=template&id=28926df1&"
import script from "./ranking-item-content.vue?vue&type=script&lang=ts&"
export * from "./ranking-item-content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28926df1')) {
      api.createRecord('28926df1', component.options)
    } else {
      api.reload('28926df1', component.options)
    }
    module.hot.accept("./ranking-item-content.vue?vue&type=template&id=28926df1&", function () {
      api.rerender('28926df1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/ranking/ranking-item-content.vue"
export default component.exports